import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Globals } from '../globals';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})


export class ReportService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {
        this.httpHeader.append('Access-Control-Allow-Origin', '*');
    }

    // Method is used for Add Company
    ExportReport(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GenerateReport';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Send Report PDF by Email
    SendReportPDFbyEmail(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/SendReportPDFbyEmail';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Export Report in PDF
    ExportReportinPDF(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/ExportReportinPDF';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get Report Data
    GetReportData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetReportData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get ReportConfig Data
    GetReportConfigData(CompanyId) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetReportConfigData?CompanyId=' + CompanyId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }


    // Get ReportConfig Data by Name
    GetReportConfigDataByName(ReportName: any, MeterMasterId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetReportConfigDataByName?ReportName=' + ReportName + '&EnergymeterMasterID=' + MeterMasterId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Export Flow Report
    ExportFlowReport(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/ExportFlowReport';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Send Report PDF by Email
    SendFlowReportbyEmail(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/SendFlowReportbyEmail';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
    saveSchedule(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/SaveSchedulerReportDetails';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetSheduleData(UserId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetScheduleReportDetailsById?UserId=' + UserId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    SaveReportConfigData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/SaveReportConfigData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    AssignReporttoUser(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/AssignReporttoUser';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetUserwiseReportList(MeterMasterId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetUserwiseReportList?MeterMasterId=' + MeterMasterId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    CheckMeterNameExist(ReportName: any, MeterMasterId: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/CheckMeterNameexistbyMeterId?ReportName=' + ReportName + '&MeterMasterId=' + MeterMasterId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get ReportConfig Child Data
    GetReportConfigChildData(ReportId, meterMasterId) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetReportConfigChildData?ReportId=' + ReportId + '&meterMasterId=' + meterMasterId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetAvgReportData(ReqObj) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetAvgReportData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetLiveDataData(ReqObj) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetLiveData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    DeleteDataofMeter(ReqObj) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/DeleteDataofMeter';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    TransScheduleReportData(ReqObj) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/TransScheduleReportData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetScheduleReportData(CompanyId) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/GetScheduleReportList?companyId=' + CompanyId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    DeleteScheduleReportdatabyId(ScheduleReportId){
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'Report' + '/DeleteScheduleReportdatabyId?ScheduleReportId=' + ScheduleReportId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }





}
